import User, { TypesUser } from './user'

export default class Navigator extends User {
    // Readonly

    constructor() {
        super()
        this.type = TypesUser.NAVIGATOR
    }

    public fromJSON(json: any): Navigator {
        super.fromJSON(json)


        return this
    }

    public toJSON(): any {
        return {
            ...super.toJSON(),
        }
    }
}
